import styled from 'styled-components';

export const ContentSide = styled.div`
  width: 48%;
`;

export const ContentBlock = styled.div`
  &:not(:last-child) {
    margin-bottom: 2rem;
  }

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-size: 1rem;
    font-weight: 700;
    margin: 0 0 0.25rem 0;
  }

  & > div.content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    & > div > div > span {
      margin-right: 0.25rem;
    }

    & > div {
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      .label {
        font-size: 0.875rem;
        color: ${({ theme }) => theme.colors.grayDark4};
        padding-bottom: 0.5rem;
      }

      & > .subtitle {
        font-size: 0.875rem;
        color: ${({ theme }) => theme.colors.grayDark2};
        font-weight: 700;
        margin-bottom: 0.25rem;
      }

      & > .description {
        font-size: 0.75rem;
        color: ${({ theme }) => theme.colors.grayDark2};
      }

      & > div.day-and-time {
        width: 11.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: max-content;
        margin-bottom: 1.5rem;
        gap: 0.5rem;

        & > span {
          font-size: 0.75rem;
          color: ${({ theme }) => theme.colors.grayDark2};
        }
      }
    }

    &.firstcolumn {
      flex-direction: column;
      & > div.dayandtime {
        width: max-content;
        margin-bottom: 1.5rem;
        gap: 0.5rem;
      }
    }

    &.responsibles {
      flex-wrap: wrap;
      justify-content: flex-start;
      flex-direction: column;
      gap: 1rem;

      & > div {
        max-width: 85%;
        margin-bottom: 0.5rem;
      }
    }
  }
`;

export const ExpandedRowContainer = styled.div`
  display: flex;
  padding: 0.5rem 1rem;
`;
